<template>
  <div id="page">
    <el-carousel height="545px" :interval="5000">
      <el-carousel-item v-for="item in banner" :key="item.bannerId">
        <img :src="item.imagePath" class="kcbao_img" @click="bannerdetail(item.chainedAddress)"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { bannerList } from "@/api/index/index.js";
export default {
  computed: {},
  data() {
    return {
      banner: [], //banner
    };
  },
  props: {
    imgList: Array,
  },
  created() {
    // banner列表
    bannerList({
      pageNum: 1,
      pageSize: 10,
    }).then((res) => {
      this.banner = res.data;
    });
  },
  methods: {
    bannerdetail(e) {
      this.$emit("bannerdetail", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-carousel{
  img{
    width: 100%;
    height: 100%;
  }
}
::v-deep .el-carousel__indicator{
  .el-carousel__button{
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
  &.is-active{
    .el-carousel__button{
      background-color: rgba(255,255,255,.9);
      //border: 4px solid #1259c4;
      box-sizing: content-box;
    }
  }
}
</style>